// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import React from 'react';
import './DimaondShapeFilter.style';
import Slider from "react-slick";
import "react-slick/dist/react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { generateQuery, getQueryParam, removeQueryParamWithoutHistory } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';
import diamond_Shape from 'Src/Value/Diamond_shape';
import Dimaondshape from './Diamonshape.component';

export class DimaondShapeFilter extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes
    };

    state = {
        shape_array: []
    }

    typesettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoPlay: false,
        responsive: [
            {
                breakpoint: 1299,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                }
            },
            {
                breakpoint: 667,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
        ]
    };

    componentDidMount() {
        const location = window?.location;
        const shapevalue = getQueryParam("shape", location || '');
        const customshapevalue = getQueryParam("customFilters", location || '');

        // if (location?.pathname?.includes("ring-diamond")) {
        if (shapevalue) {
            this.setState({ shape_array: shapevalue?.split(",") })
        }
        // } else {
        //     if (customshapevalue) {
        //         let priceIndex = customshapevalue.indexOf('shape:');

        //         let resultString = priceIndex !== -1 ? customshapevalue.substring(priceIndex).split(';')[0].replace("shape:", "").split(",") : [];

        //         this.setState({ shape_array: resultString })
        //     }
        // }
    }

    renderShapeChange = (value) => {
        const { shape_array } = this.state;
        const { renderGetDiamond } = this.props;

        if (shape_array.length <= 0) {
            shape_array.push(value.code);
        } else {
            const hasMatchingDiamond = shape_array?.some((diamond) => {
                return diamond === value.code;
            });

            if (!hasMatchingDiamond) {
                shape_array.shift(1);
                shape_array.push(value.code);
            } else {
                shape_array.splice(shape_array.indexOf(value.code), 1);
            }
        }

        this.setState({
            shape_array: shape_array
        });

        const location = window?.location;
        // const queryfilter = getQueryParam("shape", location || '');
        // let query = "";

        // if (location?.pathname?.includes("ring-diamond")) {
        if (shape_array.length <= 0) {
            removeQueryParamWithoutHistory("shape", history, location);
        } else {
            history.push(generateQuery({ shape: shape_array }, location, history));
        }

        renderGetDiamond();
        // } else {
        //     if (queryfilter) {
        //         let priceIndex = queryfilter.indexOf('shape:');
        //         let resultString = priceIndex !== -1 ? queryfilter.substring(priceIndex).split(';') : queryfilter;

        //         if (priceIndex !== -1) {
        //             query = generateQuery({ customFilters: queryfilter.replace(resultString[0], `shape:${shape_array}`) }, window.location, history);
        //         } else {
        //             query = generateQuery({ customFilters: queryfilter.concat(`;shape:${shape_array}`) }, window.location, history);
        //         }
        //     } else {
        //         query = generateQuery({ customFilters: `shape:${shape_array}` }, window.location, history);
        //     }

        //     history.push(query);
        // }
    }

    render() {
        const { shape_array } = this.state;
        const { renderGetDiamond } = this.props;
        const ringsetting = JSON.parse(localStorage.getItem("setting"));
        const ringdiamond = JSON.parse(localStorage.getItem("diamond"));
        let ringdiamondshape = [];

        if (ringsetting) {
            const shapevalue = ringsetting?.selectedcustomoptions?.find((value) => {
                return value[0] === "shape";
            });

            if (shapevalue?.length > 0) {
                const ringdiamondshapevalue = diamond_Shape?.find((value) => {
                    return value?.code === shapevalue[1]
                });

                if (ringdiamondshapevalue) {
                    ringdiamondshape = [ringdiamondshapevalue];

                    if (!shape_array.includes(ringdiamondshapevalue?.code)) {
                        this.renderShapeChange(ringdiamondshapevalue);
                        renderGetDiamond();
                    }
                }
            }
        }

        return (
            <div className="DimaondShape">
                <div className='shape-filter'>
                    {
                        ringdiamond ? <Slider {...this.typesettings}>
                            {
                                diamond_Shape?.map((value, index) => (
                                    <div
                                        onClick={() => this.renderShapeChange(value)}
                                        aria-label={value.code}
                                        key={index}
                                    >
                                        <Dimaondshape value={value} shape_array={shape_array} />
                                    </div>
                                ))
                            }
                        </Slider> : ringdiamondshape?.length > 0 && ringsetting ?
                            ringdiamondshape?.map((value, index) => (
                                <div
                                    aria-label={value.code}
                                    key={index}
                                >
                                    <Dimaondshape value={value} shape_array={shape_array} />
                                </div>
                            ))
                            : <Slider {...this.typesettings}>
                                {
                                    diamond_Shape?.map((value, index) => (
                                        <div
                                            onClick={() => this.renderShapeChange(value)}
                                            aria-label={value.code}
                                            key={index}
                                        >
                                            <Dimaondshape value={value} shape_array={shape_array} />
                                        </div>
                                    ))
                                }
                            </Slider>
                    }
                </div>
            </div>
        );
    }
}

export default DimaondShapeFilter;
